var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column small-12" },
    [
      _c("label", [
        _c("span", [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("tenantProjects.inspection.supportingDocs")) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.canEdit && _vm.inspection.id
        ? _c("HkldDropzone", {
            attrs: {
              sourceId: _vm.inspection.id,
              name: _vm.inspection.id,
              metaData: { viewInEmail: "", uploadOnTop: true },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.inspection.id
        ? _c("EditAttachments", {
            attrs: {
              uploadOnTop: true,
              sourceId: _vm.inspection.id,
              canDownloadAll: false,
              showAllDeleteBtn: false,
              canDelete: _vm.canEdit,
              canEdit: _vm.canEdit,
              attachmentTypes: _vm.attachmentTypes,
              showDeleteBtnFunc: function (item) {
                return !_vm.attachmentsInMail.has(item.id)
              },
              getFilesList: _vm.getFilesList,
              filesChanged: _vm.onChangedFiles,
              updateDescriptionCb: _vm.onChangedFiles,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }